import { createAsyncThunk } from '@reduxjs/toolkit';
import { deleteApi, getApi, postApi, putApi } from 'redux/apis';
import { AxiosError } from 'axios';

// Get All Expense Groups
export const getExpenseGroupsAction = createAsyncThunk(
    'expenseGroups/getExpenseGroups',
    async (params: any = {}, { rejectWithValue }) => {
        try {
            const response = await getApi('/expense-groups', {
                ...params,
                companyId: localStorage.getItem('companyId'),
            });
            return response.data.data;
        } catch (error: any) {
            if (!error.response) {
                throw error;
            }
            return rejectWithValue(error?.response?.data);
        }
    }
);

// Paginate Expense Groups
export const paginateExpenseGroupsAction = createAsyncThunk(
    'expenseGroups/paginateExpenseGroups',
    async (params: any = {}, { rejectWithValue, getState }: any) => {
        const alreadyAvailableExpenseGroups = getState().expenseGroups.data;
        try {
            const response = await getApi('/expense-groups', {
                ...params,
                companyId: localStorage.getItem('companyId'),
            });
            return [...alreadyAvailableExpenseGroups, ...response.data.data.data];
        } catch (error: any) {
            if (!error.response) {
                throw error;
            }
            return rejectWithValue(error?.response?.data);
        }
    }
);

// Get Single Expense Group by ID
export const getExpenseGroupByIdAction = createAsyncThunk(
    'expenseGroups/getExpenseGroupById',
    async (id: string, { rejectWithValue }) => {
        try {
            const response = await getApi(`/expense-groups/${id}`, {
                companyId: localStorage.getItem('companyId'),
            });
            return response.data;
        } catch (error: any) {
            if (!error.response) {
                throw error;
            }
            return rejectWithValue(error?.response?.data);
        }
    }
);

// Create Expense Group
export const createExpenseGroupAction = createAsyncThunk(
    'expenseGroups/createExpenseGroup',
    async (data: any, { rejectWithValue }) => {
        try {
            const response = await postApi('/expense-groups', {
                ...data,
                companyId: localStorage.getItem('companyId'),
            });
            return response.data;
        } catch (error: any) {
            if (!error.response) {
                throw error;
            }
            return rejectWithValue(error?.response?.data);
        }
    }
);

// Update Expense Group
export const updateExpenseGroupAction = createAsyncThunk(
    'expenseGroups/updateExpenseGroup',
    async (data: any, { rejectWithValue }) => {
        try {
            const response = await putApi(`/expense-groups/${data.id}?companyId=${localStorage.getItem('companyId')}`, {
                ...data,
            });
            return response.data;
        } catch (error: any) {
            if (!error.response) {
                throw error;
            }
            return rejectWithValue(error?.response?.data);
        }
    }
);

// Delete Expense Group
export const deleteExpenseGroupAction = createAsyncThunk(
    'expenseGroups/deleteExpenseGroup',
    async (id: string, { rejectWithValue }) => {
        try {
            const response = await deleteApi(`/expense-groups/${id}?companyId=${localStorage.getItem('companyId')}`);
            return { id, response: response.data };
        } catch (error: unknown) {
            const axiosError = error as AxiosError;
            if (!axiosError.response) {
                throw error;
            }
            return rejectWithValue(axiosError.response.data);
        }
    }
);
